import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { ApiResponse } from '../models/response.model';

export const responseInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        map((event) => {
            if (event instanceof HttpResponse) {
                const body = event.body;

                if (body instanceof Blob) {
                    return event;
                }

                // If the backend already returns the standardized DTO format, pass through
                if (
                    body &&
                    typeof body === 'object' &&
                    'success' in body &&
                    'message' in body &&
                    'data' in body
                ) {
                    return event;
                }

                // Wrap raw responses into the standardized ApiResponse format
                const wrapped: ApiResponse = {
                    message: 'Success',
                    data: body,
                    success: true,
                };

                return event.clone({ body: wrapped });
            }

            return event;
        })
    );
};
